import ApplePayProcess from 'app/components/OrderPayment/ApplePay/ApplePayProcess';
import React from 'react';

const ApplePayPaymentMob = () => {
  return <ApplePayProcess />;
};

export default ApplePayPaymentMob;
